import { ChangeDetectorRef, Component, DoCheck, EventEmitter, Inject, Input, Output } from '@angular/core';
@Component({
  selector: 'paginacao',
  templateUrl: './paginacao.component.html',
  styleUrls: ['./paginacao.component.css'],
})
export class PaginacaoComponent implements DoCheck {
  paginaAnterior: number = 1;
  //Outputs da Paginação
  @Input() currentPage!: number;
  @Input() collectionSize!: number;
  @Input() pageSize!: number;
  @Output() changeNumber: EventEmitter<number> = new EventEmitter();
  constructor(@Inject(ChangeDetectorRef) private changeDetector: ChangeDetectorRef) { }
  ngDoCheck(): void {
    if (this.currentPage != this.paginaAnterior) {
      this.paginaAnterior = this.currentPage;
      setTimeout(() => {
        this.changeNumber.emit(this.currentPage);
        this.changeDetector.detectChanges();
      });
    }
  }
}
